import { z } from 'zod'

export const amBrandShema = z.object({
  id: z.string(),
  name: z.string(),
  logoS3Key: z.string().optional(),
  totalLocations: z.number().optional(),
  logos: z.array(z.string()).optional(),
})

export type AMBrand = z.infer<typeof amBrandShema>

export const amBrandCategoryShema = z.object({
  category: z.string(),
  codes: z.array(z.string()),
  isTopLevel: z.boolean().optional(),
  indexForDisplay: z.number().optional(),
})

export type AMBrandCategory = z.infer<typeof amBrandCategoryShema>
